import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/* eslint-disable complexity */
/* eslint-disable max-lines,camelcase */
import { RangeFilter } from "../filters/RangeFilter";
import { arrayMinMax } from "../Utils";
import { useEffect, useState } from "react";
import { useCars, useCarsDispatch } from "./CarsContext";
import { DropDownFilter } from "../filters/DropDownFilter";
import { aboveMinKm, aboveMinPower, belowMaxDuration, belowMaxPrice, filterBody, filterColor, filterDrive, filterEqpLev, filterFuel, filterInStock, filterManufac, filterModel, filterTransition, } from "../filters/FilterFunctions";
import { removeDiacritics } from "../../utils/remove-diacritics";
export function CarsFiltration({ initialFilterData, updatePageTitle, filtersChanged }) {
    const [bodyValue, setBody] = useState([]);
    const [colorValue, setColor] = useState([]);
    const [driveValue, setDrive] = useState([]);
    const [durationRange, setDurationRange] = useState({ min: 0, max: 0 });
    const [fuelValue, setFuel] = useState([]);
    const [kmRange, setKmRange] = useState({ min: 0, max: 0 });
    const [loaded, setLoaded] = useState(false);
    const [manufacValue, setManufac] = useState([]);
    const [maxDuration, setMaxDuration] = useState(0);
    const [maxPrice, setMaxPrice] = useState(0);
    const [mdlValue, setMdl] = useState([]);
    const [minKm, setMinKm] = useState(0);
    const [minPower, setMinPower] = useState(0);
    const [powerRange, setPowerRange] = useState({ min: 0, max: 0 });
    const [priceRange, setPriceRange] = useState({ min: 0, max: 0 });
    const [stockValue, setStock] = useState(false);
    const [transValue, setTrans] = useState([]);
    const [eqpLevValue, setEqpLev] = useState([]);
    const { cars } = useCars();
    const dispatch = useCarsDispatch();
    const dropDownFiltersData = {
        body: {
            label: "Karoserie",
            items: getFilterForKey("body"),
        },
        col: {
            label: "Barva",
            items: getFilterForKey("col"),
        },
        drive: {
            label: "Pohon",
            items: getFilterForKey("drive"),
        },
        fuel_s: {
            label: "Palivo",
            items: getFilterForKey("fuel_s"),
        },
        manufac: {
            label: "Značka",
            items: getFilterForKey("manufac"),
        },
        mdl: {
            label: "Model",
            items: getFilterForKey("mdl"),
        },
        trans: {
            label: "Převodovka",
            items: getFilterForKey("trans"),
        },
        eqp_lev: {
            label: "Výbavový stupeň",
            items: getFilterForKey("eqp_lev", ['Žádný']),
        },
    };
    const URL_DEFAULT_PATH = "/nabidka-operativniho-leasingu/";
    const URL_BASE_PATH = "/operativni-leasing/";
    const URL_BASE_DELIMITER = "-";
    useEffect(() => {
        if (cars.length === 0) {
            return;
        }
        const budgets = cars.flatMap(car => car.op_leas_calcs.map(calc => calc.prc_no_vat));
        const kms = cars.flatMap(car => car.op_leas_calcs.map(calc => calc.km_y));
        const durations = cars.flatMap(car => car.op_leas_calcs.map(calc => calc.mnts));
        const powers = cars.map(car => car.pwr_kw);
        const [minBudget, maxBudget] = arrayMinMax(budgets);
        const [minKm, maxKm] = arrayMinMax(kms);
        const [minDuration, maxDuration] = arrayMinMax(durations);
        const [minPower, maxPower] = arrayMinMax(powers);
        setPriceRange({
            max: maxBudget,
            min: minBudget,
        });
        setMaxPrice(maxBudget);
        setKmRange({
            max: maxKm,
            min: minKm,
        });
        setMinKm(minKm);
        setDurationRange({
            max: maxDuration,
            min: minDuration,
        });
        setMaxDuration(maxDuration);
        setPowerRange({
            max: maxPower,
            min: minPower,
        });
        setMinPower(minPower);
        loadFilters();
        setLoaded(true);
    }, [cars]);
    function setUrl(url, search) {
        for (const [key, value] of Object.entries(search ?? {})) {
            const searchValue = (Array.isArray(value)) ? value.join(',') : value;
            if (searchValue === undefined || (Array.isArray(value) && value.length === 0)) {
                url.searchParams.delete(key);
            }
            else {
                url.searchParams.set(key, searchValue.toString());
            }
        }
        history.pushState({}, "", url);
    }
    useEffect(() => {
        if (loaded) {
            const searchObject = {
                bodyValue,
                colorValue,
                driveValue,
                fuelValue,
                manufacValue,
                maxDuration,
                maxPrice,
                mdlValue,
                minKm,
                minPower,
                stockValue,
                transValue,
                eqpLevValue,
            };
            let path = URL_DEFAULT_PATH;
            let title = "Operativní leasingy";
            if (manufacValue.length === 1) {
                path = URL_BASE_PATH + removeDiacritics(manufacValue[0]);
                title = "Operativní leasingy " + manufacValue[0];
                if (mdlValue.length === 1) {
                    path += URL_BASE_DELIMITER + removeDiacritics(mdlValue[0]);
                    title += " " + mdlValue[0];
                    if (eqpLevValue.length === 1) {
                        path += URL_BASE_DELIMITER + removeDiacritics(eqpLevValue[0]);
                        title += " " + eqpLevValue[0];
                    }
                }
            }
            updatePageTitle(title);
            setUrl(new URL(path, window.location.origin), searchObject);
            filtersChanged(searchObject);
        }
        const filteredCars = getFilteredCars();
        dispatch({
            type: "setFilteredCars",
            cars: filteredCars,
            calcAttr: {
                minKm,
                maxDuration,
                maxPrice,
            }
        });
    }, [
        maxPrice, minKm, maxDuration, minPower,
        stockValue,
        manufacValue, mdlValue, transValue, bodyValue, driveValue, fuelValue, colorValue, eqpLevValue,
    ]);
    function getFilteredCars(turnOffFilter) {
        const filtered = cars
            .filter(car => car.op_leas_calcs.some(calc => (aboveMinKm(calc, minKm) &&
            belowMaxDuration(calc, maxDuration) &&
            belowMaxPrice(calc, maxPrice))))
            .filter(car => ((turnOffFilter?.body || filterBody(car, bodyValue)) &&
            (turnOffFilter?.col || filterColor(car, colorValue)) &&
            (turnOffFilter?.drive || filterDrive(car, driveValue)) &&
            (turnOffFilter?.fuel_s || filterFuel(car, fuelValue)) &&
            (turnOffFilter?.manufac || filterManufac(car, manufacValue)) &&
            (turnOffFilter?.mdl || filterModel(car, mdlValue)) &&
            (turnOffFilter?.trans || filterTransition(car, transValue)) &&
            (turnOffFilter?.eqp_lev || filterEqpLev(car, eqpLevValue)) &&
            aboveMinPower(car, minPower) &&
            filterInStock(car, stockValue)));
        const sorted = filtered.sort((carA, carB) => {
            const filteredCalcA = carA.op_leas_calcs.find((calc) => {
                return aboveMinKm(calc, minKm) && belowMaxDuration(calc, maxDuration) && belowMaxPrice(calc, maxPrice);
            });
            const filteredCalcB = carB.op_leas_calcs.find((calc) => {
                return aboveMinKm(calc, minKm) && belowMaxDuration(calc, maxDuration) && belowMaxPrice(calc, maxPrice);
            });
            const priceA = filteredCalcA?.prc_no_vat ?? carA.op_leas_calcs[0].prc_no_vat;
            const priceB = filteredCalcB?.prc_no_vat ?? carB.op_leas_calcs[0].prc_no_vat;
            return priceA - priceB;
        });
        return sorted;
    }
    function getFilterForKey(key, excludedValues = []) {
        const map = new Map([]);
        excludedValues.forEach((excludedValue) => map.set(excludedValue, true));
        const cars = getFilteredCars({ [key]: true });
        return Array.from(new Set(cars.map(car => car[key])))
            .filter(value => value !== undefined)
            .filter(value => !map.has(value));
    }
    function loadFilter(currentValue, setter, value) {
        if (!value) {
            return;
        }
        if (typeof currentValue === "number") {
            setter(Number(value));
        }
        else if (Array.isArray(currentValue)) {
            setter(value.split(","));
        }
        else if (typeof currentValue === "boolean") {
            setter((value === "true"));
        }
        else {
            setter(value);
        }
    }
    function loadFilters() {
        const url = new URLSearchParams(window.location.search);
        const queryParams = Object.fromEntries(url.entries());
        loadFilter(bodyValue, setBody, queryParams["bodyValue"]);
        loadFilter(colorValue, setColor, queryParams["colorValue"]);
        loadFilter(driveValue, setDrive, queryParams["driveValue"]);
        loadFilter(fuelValue, setFuel, queryParams["fuelValue"]);
        loadFilter(manufacValue, setManufac, queryParams["manufacValue"] ?? initialFilterData?.manufacValue);
        loadFilter(maxDuration, setMaxDuration, queryParams["maxDuration"]);
        loadFilter(maxPrice, setMaxPrice, queryParams["maxPrice"]);
        loadFilter(mdlValue, setMdl, queryParams["mdlValue"] ?? initialFilterData?.mdlValue);
        loadFilter(minKm, setMinKm, queryParams["minKm"]);
        loadFilter(minPower, setMinPower, queryParams["minPower"]);
        loadFilter(stockValue, setStock, queryParams["stockValue"]);
        loadFilter(transValue, setTrans, queryParams["transValue"]);
        loadFilter(eqpLevValue, setEqpLev, queryParams["eqpLevValue"] ?? initialFilterData?.eqpLevValue);
        loadFilter(loaded, setLoaded, queryParams["loaded"]);
    }
    function resetFilters() {
        setBody([]);
        setColor([]);
        setDrive([]);
        setFuel([]);
        setManufac([]);
        setMaxDuration(durationRange.max);
        setMaxPrice(priceRange.max);
        setMdl([]);
        setMinKm(kmRange.min);
        setMinPower(powerRange.min);
        setStock(false);
        setTrans([]);
        setEqpLev([]);
        const groups = Array.from(document.getElementsByClassName('car-filtr__group--open'));
        groups.map(group => {
            group.classList.remove('car-filtr__group--open');
        });
        document.body.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth",
        });
    }
    return _jsx(_Fragment, { children: _jsxs("div", { className: "car-filtr", children: [_jsx(RangeFilter, { label: "Rozpo\u010Det", type: "max", suffix: "K\u010D / m\u011Bs\u00EDc", range: priceRange, id: "budget", value: maxPrice, step: 1000, valueChanged: (maxPrice) => setMaxPrice(maxPrice) }), _jsx(RangeFilter, { label: "Ro\u010Dn\u00ED n\u00E1jezd", type: "min", suffix: "km", range: kmRange, id: "km", value: minKm, step: 5000, valueChanged: (minKm) => setMinKm(minKm) }), _jsx(RangeFilter, { label: "Doba n\u00E1jmu", type: "max", suffix: "m\u011Bs\u00EDc\u016F", range: durationRange, id: "duration", value: maxDuration, step: 12, valueChanged: (maxDuration) => setMaxDuration(maxDuration) }), _jsxs("div", { className: "car-filtr__checkbox-item", children: [_jsx("label", { className: "car-filtr__label", htmlFor: "stock", children: "Jen skladem" }), _jsx("input", { id: "stock", type: "checkbox", value: "stock", className: "car-filtr__checkbox", checked: stockValue, onChange: () => setStock(!stockValue) })] }), _jsxs("div", { className: "car-filtr__more", children: [_jsx("div", { className: "car-filtr__headline", children: "Parametry auta" }), _jsx(DropDownFilter, { id: "manufac", label: dropDownFiltersData.manufac.label, items: dropDownFiltersData.manufac.items, values: manufacValue, valueChanged: (manufacValue) => setManufac(manufacValue) }), _jsx(DropDownFilter, { id: "mdl", label: dropDownFiltersData.mdl.label, items: dropDownFiltersData.mdl.items, values: mdlValue, valueChanged: (mdlValue) => setMdl(mdlValue) }), _jsx(DropDownFilter, { id: "trans", label: dropDownFiltersData.trans.label, items: dropDownFiltersData.trans.items, values: transValue, valueChanged: (transValue) => setTrans(transValue) }), _jsx(DropDownFilter, { id: "body", label: dropDownFiltersData.body.label, items: dropDownFiltersData.body.items, values: bodyValue, valueChanged: (bodyValue) => setBody(bodyValue) }), _jsx(DropDownFilter, { id: "eqp_lev", label: dropDownFiltersData.eqp_lev.label, items: dropDownFiltersData.eqp_lev.items, values: eqpLevValue, valueChanged: (eqpLevValue) => setEqpLev(eqpLevValue) }), _jsx(DropDownFilter, { id: "drive", label: dropDownFiltersData.drive.label, items: dropDownFiltersData.drive.items, values: driveValue, valueChanged: (driveValue) => setDrive(driveValue) }), _jsx(DropDownFilter, { id: "fuel", label: dropDownFiltersData.fuel_s.label, items: dropDownFiltersData.fuel_s.items, values: fuelValue, valueChanged: (fuelValue) => setFuel(fuelValue) }), _jsx(DropDownFilter, { id: "color", label: dropDownFiltersData.col.label, items: dropDownFiltersData.col.items, values: colorValue, valueChanged: (colorValue) => setColor(colorValue) }), _jsx(RangeFilter, { label: "V\u00FDkon motoru", type: "min", suffix: "kW", range: powerRange, id: "power", value: minPower, step: 1, customClass: "car-filtr__range--light", valueChanged: (minPower) => setMinPower(minPower) })] }), _jsxs("div", { className: "car-filtr__cancel", onClick: resetFilters, children: [_jsx("span", { className: "car-filtr__cancel-icon icon icon--trash" }), "Zru\u0161it filtry"] })] }) });
}
